exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".col-center[data-v-6edfa91e]{text-align:center}", "", {"version":3,"sources":["/workspace/src/views/permission-apply/pages/PermissionApplyTable.vue"],"names":[],"mappings":"AACA,6BAA6B,iBAAiB,CAC7C","file":"PermissionApplyTable.vue","sourcesContent":["\n.col-center[data-v-6edfa91e]{text-align:center\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6edfa91e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/permission-apply/pages/PermissionApplyTable.vue
// module id = 5053
// module chunks = 153